import classNames from 'classnames';
import TableCell from './TableCell';
import TableRow from './TableRow';
import React from 'react';
import PropTypes from 'prop-types';
import styles from './css/Table.scss';

export default function Table({
    children,
    className,
}) {
    const classes = classNames(className, styles.table);
    return (
        <div className={classes}>
            {children}
        </div>
    );
}

Table.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};

Table.Cell = TableCell;
Table.Row = TableRow;
